<template>
  <div class="dppl-select">
    <label class="form-label-text">{{ label }}</label>
    <v-autocomplete
      v-if="searchSelect"
      v-bind="{ ...$props, ...$attrs }"
      :variant="variant"
      density="compact"
      autofocus
      @update:menu="onMenuUpdate"
    >
      <template #prepend-inner>
        <v-icon icon="$magnify" />
      </template>
      <slot />
    </v-autocomplete>
    <v-select
      v-else
      v-bind="{ ...$props, ...$attrs }"
      :variant="variant"
      density="compact"
    >
      <slot />
    </v-select>
  </div>
</template>
<script>
export default {
  name: 'DpplSelect',
  props: {
    label: { default: '', type: String },
    variant: { default: 'outlined', type: String },
    searchSelect: { default: false, type: Boolean },
    selectOnOpenMenu: { default: false, type: Boolean },
  },
  methods: {
    onMenuUpdate(isOpen) {
      if (this.selectOnOpenMenu && isOpen) {
        setTimeout(() => {
          const input = this.$el.querySelector('input');
          if (input) {
            input.select();
          }
        }, 100);
      }
    },
  },
};
</script>
<style scoped lang="less">
// Control
.dppl-select {
  &[disabled="true"] .v-select {
    opacity: 0.7;
  }
}

.v-input {
  color: @text-darkest;
  font-weight: 300;

  :deep(.v-field__input) {
    opacity: 1;
  }

  :deep(.v-field__outline) {
    --v-field-border-opacity: 0.4;
  }

  :deep(.v-field__outline__notch label) {
    display: none;
  }

  :deep(.v-field:hover .v-field__outline) {
    --v-field-border-opacity: 1;
  }

  :deep(.v-field--focused .v-field__outline) {
    color: @text-brand;
    --v-field-border-opacity: 1;
  }

  :deep(.v-input__details) {
    padding-left: 0;
    // always hide error message container
    display: none;
  }
  // but show it if there's an error
  &.v-input--error {
    :deep(.v-input__details) {
      display: initial;
    }
  }
}

// Items
:deep(.v-list-item__content) {
  color: @text-darkest;
}

:deep(.v-list-item__content) {
  .v-list-item__title {
    font-weight: 300;
  }
}

.v-subheader {
  font-weight: 500;
}
</style>
